<template>
  <transition mode="out-in" appear @enter="enter" @leave="leave" :css="false">
    <section class="purple">
      <div class="purple__bg">
        <div class="purple__bg-view"></div>
      </div>
      <FrameBook></FrameBook>
      <div class="purple__contents" :class="'purple__contents-'+ locale">
        <div class="purple__txt">
          <div class="purple__txt-bl">
            <span class="bl--1"></span><span class="bl--2"></span
            ><span class="bl--3"></span>
            <hr class="bl--r" />
            <hr class="bl--l" />
          </div>
          <div class="purple__txt-tit">
            <span class="blind" v-html="$t('purple.tit')"></span>
          </div>
          <div class="purple__txt-logo"><span class="blind">PURPLE</span></div>
        </div>

        <div class="purple__btn-wrap-top">
          <a
            href="https://gs-purple.download.ncupdate.com/Purple/PurpleInstaller_0_9_4_477.exe"
            class="purple__btn purple__btn-window"
            ><span class="blind">download for window</span></a
          >
          <a
            href="https://purple.onelink.me/HYyc/e0c08fe1"
            class="purple__btn purple__btn-app"
            ><span class="blind">download for appstore</span></a
          >
          <a
            href="https://purple.onelink.me/bZLX/f490d6f"
            class="purple__btn purple__btn-android"
            ><span class="blind">download for android</span></a
          >

          <!-- /*
          <button class="purple__btn purple__btn-window" @click="purpleAlert()"><span class="blind">download for window</span></button>
          <button class="purple__btn purple__btn-app" @click="purpleAlert()"><span class="blind">download for appstore</span></button>
          <button class="purple__btn purple__btn-android" @click="purpleAlert()"><span class="blind">download for android</span></button>
          */ -->
        </div>

        <div class="purple__drag-info">
          <div class="purple__drag-img drag-img-1">
            <button class="purple__drag-btn"></button>
          </div>
          <div class="purple__drag-img drag-img-2">
            <button class="purple__drag-btn"></button>
          </div>
          <div class="purple__drag-img drag-img-3">
            <button class="purple__drag-btn"></button>
          </div>
        </div>

        <div class="purple__btn-wrap-bottom">
          <a :href="purpleDownLink" class="purple__btn purple__btn-mobile"
            ><span class="blind">download for mobile</span></a
          >

          <!-- /*
          <button class="purple__btn purple__btn-mobile" @click="purpleAlert()"><span class="blind">download for mobile</span></button>
          */ -->
        </div>

        <p class="purple__info-txt" v-html="purpleInfoString[lang]"></p>

      </div>

      <Footer></Footer>

      <div class="purple__layer-wrap">
        <div class="purple__layer">
          <div class="purple__layer-img layer-img-1">
            <p class="purple__layer-txt txt-1" v-html="layerTextString[lang][1][1]"></p>
            <p class="purple__layer-txt txt-2" v-html="layerTextString[lang][1][2]"></p>
            <p class="purple__layer-txt txt-3" v-html="layerTextString[lang][1][3]"></p>
          </div>
          <div class="purple__layer-img layer-img-2">
            <p class="purple__layer-txt txt-1" v-html="layerTextString[lang][2][1]"></p>
            <p class="purple__layer-txt txt-2" v-html="layerTextString[lang][2][2]"></p>
            <p class="purple__layer-txt txt-3" v-html="layerTextString[lang][2][3]"></p>
          </div>
          <div class="purple__layer-img layer-img-3">
            <p class="purple__layer-txt txt-1" v-html="layerTextString[lang][3][1]"></p>
            <p class="purple__layer-txt txt-2" v-html="layerTextString[lang][3][2]"></p>
            <p class="purple__layer-txt txt-3" v-html="layerTextString[lang][3][3]"></p>
          </div>
        </div>
        <button class="purple__layer-close"></button>
      </div>
      <div class="purple__layer-dimmed"></div>
    </section>
  </transition>
</template>

<script>
import BaseSection from "./mixins/BaseSection.js";
import gsap from "gsap";
import FrameBook from "@/components/FrameBook";
import Footer from "../components/Footer";
import { mapState } from "vuex";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import promokit from "@/utils/promokit";

export default {
  name: "purple",
  components: { FrameBook, Footer},
  mixins: [BaseSection],
  data() {
    return {
      name: "purple",
      bg: null,
      os: promokit.util.getOs(),
      slickOptions: {
        variableWidth: true,
        arrows: false,
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
      },
      layerSlickOptions1:{
        variableWidth: true,
        arrows: true,
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
      },
      layerSlickOptions2:{
        variableWidth: true,
        arrows: true,
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
      layerSlickOptions3:{
        variableWidth: true,
        arrows: true,
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 2,
      },
      layerTextString: {
        'ko' : {
          1 : {
            1 : `최대 4K급<br>고퀄리티 그래픽 지원`,
            2 : `키보드 / 마우스 컨트롤 지원<br>단축키 커스텀 지원`,
            3 : `안정적인 플레이 환경<br>높은 보안 수준 제공`,
          },
          2 : {
            1 : `실행 중 PC게임<br>모바일로 원격 플레이 지원`,
            2 : `캐릭터 피격/사망 시<br>모바일 PUSH 알림`,
            3 : `거래소∙PvP 기록 등<br>내 캐릭터 정보 조회`,
          },
          3 : {
            1 : `게임 접속 없이<br>게임속 친구와 대화 가능`,
            2 : `고품질∙저지연<br>보이스 채팅`,
            3 : `내 게임 화면을<br>실시간 화면 공유`,
          }
        },
        'en' : {
          1 : {
            1 : `Max 4K resolution<br>High-quality graphics`,
            2 : `Keyboard & mouse control<br>Customizable hotkeys`,
            3 : `Flawless play environment<br>includes tight security`,
          },
          2 : {
            1 : `Play seamlessly from<br>PC PURPLE to Mobile PURPLE`,
            2 : `Get notified on mobile<br>if your character dies or gets killed`,
            3 : `View your information, including<br>trades, PvP records and more`,
          },
          3 : {
            1 : `Chat with your game friends<br>without having to sign in`,
            2 : `High quality, Low latency,<br>Voice Chat`,
            3 : `Share your screen<br>in real time`,
          }
        },
        'zh' : {
          1 : {
            1 : `支援最高4K<br>的高水準畫質`,
            2 : `支援鍵盤/滑鼠<br>支援客製化熱鍵`,
            3 : `安定的遊玩環境<br>提供高安全防護水準`,
          },
          2 : {
            1 : `可透過手機遠端遊玩<br>電腦正在執行中的遊戲`,
            2 : `角色遭受攻擊/死亡時<br>可透過手機推播通知`,
            3 : `可查詢自己角色的<br>交易所/PvP紀錄等資訊`,
          },
          3 : {
            1 : `即使沒有連接遊戲<br>也可以和遊戲中的好友進行對話`,
            2 : `高品質/低延遲<br>語音聊天`,
            3 : `可即時共享<br>我的遊戲畫面`,
          }
        },
        'ja' : {
          1 : {
            1 : `最大4K<br>ハイクオリティなグラフィックの提供`,
            2 : `キーボード/マウス コントロール支援<br>ショートカットキー カスタマイズ支援`,
            3 : `安定したプレイ環境<br>高いセキュリティレベルの提供`,
          },
          2 : {
            1 : `実行中のPCゲーム<br>モバイルで遠隔プレイ支援`,
            2 : `攻撃された時/死亡時<br>モバイルにPUSH通知`,
            3 : `取引所/PvP記録など<br>自分のキャラクター情報照会`,
          },
          3 : {
            1 : `ゲームに接続しなくても<br>フレンドとチャットが可能`,
            2 : `高品質/低遅延<br>ボイス チャット`,
            3 : `自分のゲーム画面を<br>リアルタイムで画面共有`,
          }
        }
      },
      purpleInfoString: {
        'ko' : "“정식 오픈 이후 퍼플의 다양한 기능을 사용할 수 있습니다.”",
        'en' : "“Some PURPLE features will be available after the official release.”",
        'ja' : "「正式オープン後、PURPLEの様々な機能が使用できます」",
        'zh' : "「正式上市後，將可以使用PURPLE的各種功能。」",
      }
    };
  },
  computed: {
    ...mapState(["breakPoint", "documentSize", "locale", "lang"]),
    purpleDownLink() {
      if (this.os === "android") {
        return "https://purple.onelink.me/bZLX/f490d6f";
      } else if (this.os === "ios") {
        return "https://purple.onelink.me/HYyc/e0c08fe1";
      } else {
        return "https://ncpurple.com/intro?utm_source=web_lw&utm_medium=purplehome_lw&utm_campaign=lw_teasing&utm_content=button";
      }
    },
  },
  methods: {
    setMotion() {
      this.enterMotion = new gsap.timeline({
        paused: true,
        onStart: () => {
          this.setIsMovePage(true);
        },
      });
      this.enterMotion
        .addLabel("start")
        .from(this.$el, 0.5, { opacity: 0, ease: "power2.easeOut" });
      this.titMotion = new gsap.timeline({ paused: true });
      this.titMotion
        .addLabel("title")
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--1`),
          0.4,
          { autoAlpha: 0, rotation: 190 },
          { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--2`),
          0.4,
          { autoAlpha: 0, rotation: -190 },
          { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--3`),
          0.4,
          { autoAlpha: 0, scale: 3 },
          { autoAlpha: 1, scale: 1, ease: "Back.easeOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--r`),
          0.4,
          { autoAlpha: 0, x: -30, y: -5 },
          { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--l`),
          0.4,
          { autoAlpha: 0, x: 30, y: -5 },
          { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-tit`),
          0.4,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.4"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-logo`),
          0.4,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.4"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__btn-wrap-top`),
          0.4,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.6"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__drag-info`),
          0.4,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.8"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__btn-wrap-bottom`),
          0.4,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=1"
        );
    },
    leave(el, done) {
      gsap.to(this.$el, 0.5, { opacity: 0, onComplete: done });
    },
    enter(el, done) {
      this.setMotion();
      this.enterMotion.eventCallback("onComplete", () => {
        done();
        setTimeout(() => {
          this.setIsMovePage(false);
        }, 1000);
      });
      if (this.currentPage == "index") this.autoPlay = false;
      this.setCurrentPage(this.name);
      this.setEnterPage(this);
    },
    start() {
      this.enterMotion.play();
      this.titMotion.play();
    },
    purpleAlert(){
      let purpleAlertMessage = 'test';

      if(this.lang === 'ko'){
        purpleAlertMessage = '"서비스 준비 중"'
      }
      else if(this.lang === 'en'){
        purpleAlertMessage = '"Coming Soon"'
      }
      else if(this.lang === 'zh'){
        purpleAlertMessage = '「服務準備中」'
      }
      else if(this.lang === 'ja'){
        purpleAlertMessage = '「サービス準備中」'
      }

      window.alert(purpleAlertMessage);
    }
  },
  mounted() {
    if (this.autoPlay) {
      this.start();
      this.setIsIntro(false);
    }

    if (this.documentSize.w <= 960) {
      $(this.$el).find(".purple__drag-info").slick(this.slickOptions);
    }

    this.$watch("documentSize", (val) => {
      if (val.w <= 960) {
        if (!$(this.$el).find(".purple__drag-info").hasClass("slick-initialized")){
          $(this.$el).find(".purple__drag-info").slick(this.slickOptions);
        }
      }
      else {
        if ($(this.$el).find(".purple__drag-info").hasClass("slick-initialized")){
          $(this.$el).find(".purple__drag-info").slick("unslick");
        }
      }
    });

    $(".drag-img-1 .purple__drag-btn").on('click', function(){
      $(".purple__layer").slick(
          {
            variableWidth: true,
            arrows: true,
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0,
          }
      );
      $(".purple__layer-dimmed").show();
      $(".purple__layer-wrap").show();
    });

    $(".drag-img-2 .purple__drag-btn").on('click', function(){
      $(".purple__layer").slick(
          {
            variableWidth: true,
            arrows: true,
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
          }
      );
      $(".purple__layer-dimmed").show();
      $(".purple__layer-wrap").show();
    });

    $(".drag-img-3 .purple__drag-btn").on('click', function(){
      $(".purple__layer").slick(
          {
            variableWidth: true,
            arrows: true,
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 2,
          }
      );
      $(".purple__layer-dimmed").show();
      $(".purple__layer-wrap").show();
    });

    $('.purple__layer-dimmed, .purple__layer-close').on('click', function(){
      $(".purple__layer-dimmed").hide();
      $(".purple__layer").slick("unslick");
      $(".purple__layer-wrap").hide();
    });
  },
};
</script>

<style lang="scss">
.blind {
  position: absolute;
  clip: rect(0 0 0 0);
  width: 1px;
  height: 1px;
  margin: -1px;
  overflow: hidden;
}
.purple {
  //@include bg($bg: '../assets/img/purple_guide.jpg');
  &__bg {
    @include position($width: 100%, $height: 100%);
    @include bg($bg: "../assets/img/purple_bg.jpg", $cover: cover);
    overflow: hidden;
    &-view {
      @include position(
        $position: absolute,
        $top: 0,
        $left: 0,
        $width: 100%,
        $height: 100%
      );
      //@include bg($bg: '../assets/img/purple_bg.jpg', $cover: cover);
    }
  }
  &__contents {
    @include position($position: absolute, $top: 50%, $left: 50%);
    width: 100%;
    height: 100%;
    min-width: 1300px;
    //  background: #f0f;
    &-TW{
      @include bp(tablet) {
        margin-top: -15px;
        .purple__drag-info{
          top: 170px;
        }
        .purple__btn-wrap-bottom{
         top: 495px
        }
      }
    }
  }
  &__txt {
    @include position(
      $position: absolute,
      $width: 1299px,
      $height: 513px,
      $top: -10px,
      $left: 50%
    );
    @include bg($bg: "../assets/img/purple_title_bg.png", $cover: cover);
    background-position: 46px 0;

    &-bl {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 34px,
        $top: 112px,
        $left: 50%
      );
      > span {
        display: block;
        @include position(
          $position: absolute,
          $width: 34px,
          $height: 34px,
          $top: 0,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_b.png");
        &:nth-child(1) {
          background-position-x: 0;
        }
        &:nth-child(2) {
          background-position-x: -34px;
        }
        &:nth-child(3) {
          background-position-x: -68px;
        }
      }
      > hr {
        border: none;
        @include position(
          $position: absolute,
          $width: 96px,
          $height: 14px,
          $top: 2px,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_l.png");
        margin-left: 17px;
        &:last-child {
          @include bg($bg: "../assets/img/tit_icon_r.png");
          margin-left: -113px;
        }
      }
    }

    &-tit {
      @include position(
        $position: absolute,
        $width: 800px,
        $height: 59px,
        $top: 170px,
        $left: 50%
      );
      @include hide-text;
      .ko & {
        @include bg($bg: "../assets/img/ko/purple_title.png", $cover: cover);
      }
      .en & {
        height: 63px;
        @include bg($bg: "../assets/img/en/purple_title_en.png", $cover: cover);
      }
      .zh & {
        height: 56px;
        @include bg($bg: "../assets/img/zh/purple_title_zh.png", $cover: cover);
      }
      .ja & {
        @include bg($bg: "../assets/img/ja/purple_title_ja.png", $cover: cover);
      }
    }
    &-logo {
      @include position(
        $position: absolute,
        $width: 261px,
        $height: 55px,
        $top: 235px,
        $left: 50%
      );
      @include bg($bg: "../assets/img/purple_logo.png", $cover: cover);
    }
  }

  &__layer{
    &-wrap{
      position: absolute;
      z-index: 1500;
      top: 50%;
      left: 50%;
      margin: -298px -479px;
      display: none;
      width: 957px !important;
      height: 595px;
    }
    &-img{
      position: relative;
      display: inline-block;
      width: 957px !important;
      height: 595px;
      .ko & {
        &.layer-img-1{
          @include bg($bg: "../assets/img/ko/purple_layer_1.png", $cover: cover);
        }
        &.layer-img-2{
          @include bg($bg: "../assets/img/ko/purple_layer_2.png", $cover: cover);
        }
        &.layer-img-3{
          @include bg($bg: "../assets/img/ko/purple_layer_3.png", $cover: cover);
        }
      }
      .en & {
        &.layer-img-1{
          @include bg($bg: "../assets/img/en/purple_layer_1_en.png", $cover: cover);
        }
        &.layer-img-2{
          @include bg($bg: "../assets/img/en/purple_layer_2_en.png", $cover: cover);
        }
        &.layer-img-3{
          @include bg($bg: "../assets/img/en/purple_layer_3_en.png", $cover: cover);
        }
      }
      .zh & {
        &.layer-img-1{
          @include bg($bg: "../assets/img/zh/purple_layer_1_zh.png", $cover: cover);
        }
        &.layer-img-2{
          @include bg($bg: "../assets/img/zh/purple_layer_2_zh.png", $cover: cover);
        }
        &.layer-img-3{
          @include bg($bg: "../assets/img/zh/purple_layer_3_zh.png", $cover: cover);
        }
      }
      .ja & {
        &.layer-img-1{
          @include bg($bg: "../assets/img/ja/purple_layer_1_ja.png", $cover: cover);
        }
        &.layer-img-2{
          @include bg($bg: "../assets/img/ja/purple_layer_2_ja.png", $cover: cover);
        }
        &.layer-img-3{
          @include bg($bg: "../assets/img/ja/purple_layer_3_ja.png", $cover: cover);
        }
      }
    }
    &-txt{
      position: absolute;
      font-size: 16px;
      color: #e0d0aa;
      &.txt-1{
        top: 214px;
        left: 644px;
      }
      &.txt-2{
        top: 334px;
        left: 644px;
      }
      &.txt-3{
        top: 458px;
        left: 644px;
      }
    }
    &-dimmed{
      display: none;
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1000;
      background: rgba(0,0,0,0.6);
    }
    .slick-dots{
      bottom: 65px;
      .slick-active{
        button{
          background-position-y: -20px;
        }
      }
      button{
        width: 20px;
        height: 20px;
        background-size: cover;
      }
    }
    .slick-arrow{
      left: -30px;
    }
    .slick-next{
      right: -25px;
      left: auto;
    }
    &-close{
      position: absolute;
      top: 30px;
      right: 30px;
      z-index: 10;
      width: 37px;
      height: 37px;
      @include bg($bg: "../assets/img/btn_purple_layer_close.png", $cover: cover);
    }
  }

  &__drag {
    &-btn{
      position: absolute;
      bottom: 25px;
      right: 20px;
      width: 56px;
      height: 56px;
      z-index: 10;
      @include bg($bg: "../assets/img/btn_purple_drag.png", $cover: cover);
    }
    &-info {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: auto,
        $top: 395px,
        $left: 50%
      );
      text-align: center;
      white-space: nowrap;
      //html[data-locale="KR"] & {
      //  top: 460px;
      //}
    }
    &-img {
      position: relative;
      display: inline-block;
      width: 380px;
      height: 480px;
      margin-left: 20px;
      &:after {
        position: absolute;
        top: -57px;
        left: -20px;
        width: 430px;
        height: 580px;
        pointer-events: none;
        content: "";
      }
      &.drag-img-1 {
        &:after {
          .ko & {
            @include bg(
              $bg: "../assets/img/ko/purple_drag_bg_1.png",
              $cover: cover
            );
          }
          .en & {
            @include bg(
              $bg: "../assets/img/en/purple_drag_bg_1_en.png",
              $cover: cover
            );
          }
          .zh & {
            @include bg(
              $bg: "../assets/img/zh/purple_drag_bg_1_zh.png",
              $cover: cover
            );
          }
          .ja & {
            @include bg(
              $bg: "../assets/img/ja/purple_drag_bg_1_ja.png",
              $cover: cover
            );
          }
        }
      }
      &.drag-img-2 {
        &:before {
          @include position(
            $position: absolute,
            $width: 162px,
            $height: 238px,
            $top: 144px,
            $left: -70px
          );
          @include bg($bg: "../assets/img/purple_line_bg.png", $cover: cover);
          z-index: 1;
          content: "";
        }
        &:after {
          .ko & {
            @include bg(
              $bg: "../assets/img/ko/purple_drag_bg_2.png",
              $cover: cover
            );
          }
          .en & {
            @include bg(
              $bg: "../assets/img/en/purple_drag_bg_2_en.png",
              $cover: cover
            );
          }
          .zh & {
            @include bg(
              $bg: "../assets/img/zh/purple_drag_bg_2_zh.png",
              $cover: cover
            );
          }
          .ja & {
            @include bg(
              $bg: "../assets/img/ja/purple_drag_bg_2_ja.png",
              $cover: cover
            );
          }
        }
      }
      &.drag-img-3 {
        &:after {
          .ko & {
            @include bg(
              $bg: "../assets/img/ko/purple_drag_bg_3.png",
              $cover: cover
            );
          }
          .en & {
            @include bg(
              $bg: "../assets/img/en/purple_drag_bg_3_en.png",
              $cover: cover
            );
          }
          .zh & {
            @include bg(
              $bg: "../assets/img/zh/purple_drag_bg_3_zh.png",
              $cover: cover
            );
          }
          .ja & {
            @include bg(
              $bg: "../assets/img/ja/purple_drag_bg_3_ja.png",
              $cover: cover
            );
          }
        }
      }
    }
  }
  &__btn {
    position: relative;
    display: inline-block;
    width: 208px;
    height: 65px;
    &:after {
      position: absolute;
      top: -58px;
      left: -25px;
      width: 258px;
      height: 180px;
      content: "";
      pointer-events: none;
    }
    & + & {
      margin-left: 16px;
    }
    &-wrap-top {
      display: block;
      @include position($position: absolute, $top: 305px, $left: 50%);
      font-size: 0;
      white-space: nowrap;
    }
    &-wrap-bottom {
      display: none;
    }
    &.purple__btn-window {
      &:after {
        @include bg($bg: "../assets/img/purple_btn_window.png", $cover: cover);
      }
    }
    &.purple__btn-app {
      &:after {
        @include bg($bg: "../assets/img/purple_btn_app.png", $cover: cover);
      }
    }
    &.purple__btn-android {
      &:after {
        @include bg($bg: "../assets/img/purple_btn_android.png", $cover: cover);
      }
    }
  }

  &__info-txt{
    position: absolute;
    top: 895px;
    left: 50%;
    width: 100%;
    height: auto;
    margin-left: -50%;
    text-align: center;
    white-space: nowrap;
    color: #d98f58;
    font-size: 16px;
    z-index: 10;
  }
  @include bp(tablet) {
    &__bg {
      min-height: auto;
    }
    &__contents {
      z-index: 20;
    }
    &__txt {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: auto,
        $top: 44px,
        $left: 50%
      );
      background-image: none;
      &-bl {
        display: none;
      }
      &-tit {
        @include position(
          $position: relative,
          $width: 300px,
          $height: 99px,
          $top: auto,
          $left: auto
        );
        height: 99px !important;
        margin: 0 auto;
        .ko & {
          @include bg(
            $bg: "../assets/img/ko/purple_title_m.png",
            $cover: cover
          );
        }
        .en & {
          @include bg(
            $bg: "../assets/img/en/purple_title_en_m.png",
            $cover: cover
          );
        }
        .zh & {
          @include bg(
            $bg: "../assets/img/zh/purple_title_zh_m.png",
            $cover: cover
          );
          margin-top: -15px;
        }
        .ja & {
          @include bg(
            $bg: "../assets/img/ja/purple_title_ja_m.png",
            $cover: cover
          );
          margin-top: -15px;
        }
      }
      &-logo {
        @include position(
          $position: relative,
          $width: 155px,
          $height: 33px,
          $top: auto,
          $left: auto
        );
        @include bg($bg: "../assets/img/purple_logo.png", $cover: cover);
        margin: -20px auto 0;
      }
    }
    &__layer{

      &-wrap{
        margin: -254px -167px;
        width: 334px !important;
        height: 508px;
      }
      &-img{
        width: 334px !important;
        height: 508px;
        .ko & {
          &.layer-img-1{
            @include bg($bg: "../assets/img/ko/purple_layer_1_m.png", $cover: cover);
          }
          &.layer-img-2{
            @include bg($bg: "../assets/img/ko/purple_layer_2_m.png", $cover: cover);
          }
          &.layer-img-3{
            @include bg($bg: "../assets/img/ko/purple_layer_3_m.png", $cover: cover);
          }
        }
        .en & {
          &.layer-img-1{
            @include bg($bg: "../assets/img/en/purple_layer_1_en_m.png", $cover: cover);
          }
          &.layer-img-2{
            @include bg($bg: "../assets/img/en/purple_layer_2_en_m.png", $cover: cover);
          }
          &.layer-img-3{
            @include bg($bg: "../assets/img/en/purple_layer_3_en_m.png", $cover: cover);
          }
        }
        .zh & {
          &.layer-img-1{
            @include bg($bg: "../assets/img/zh/purple_layer_1_zh_m.png", $cover: cover);
          }
          &.layer-img-2{
            @include bg($bg: "../assets/img/zh/purple_layer_2_zh_m.png", $cover: cover);
          }
          &.layer-img-3{
            @include bg($bg: "../assets/img/zh/purple_layer_3_zh_m.png", $cover: cover);
          }
        }
        .ja & {
          &.layer-img-1{
            @include bg($bg: "../assets/img/ja/purple_layer_1_ja_m.png", $cover: cover);
          }
          &.layer-img-2{
            @include bg($bg: "../assets/img/ja/purple_layer_2_ja_m.png", $cover: cover);
          }
          &.layer-img-3{
            @include bg($bg: "../assets/img/ja/purple_layer_3_ja_m.png", $cover: cover);
          }
        }
      }
      &-txt{
        font-size: 11px;
        z-index: 10;
        min-width: 200px;
        letter-spacing: 0.2px;
        &.txt-1{
          top: 288px;
          left: 120px;
        }
        &.txt-2{
          top: 352px;
          left: 120px;
        }
        &.txt-3{
          top: 418px;
          left: 120px;
        }
      }
      .slick-dots{
        bottom: 22px;
      }
      .slick-arrow{
        left: -15px;
      }
      .slick-next{
        right: -10px;
        left: auto;
      }
      &-close{
        top: 15px;
        right: 15px;
        width: 20px;
        height: 20px;
      }
    }

    &__drag {
      &-btn{
        right: 0;
        bottom: 5px;
        width: 50px;
        height: 50px;
      }
      &-info {
        @include position(
          $position: absolute,
          $width: 270px,
          $height: auto,
          $top: 190px,
          $left: 50%
        );
        margin-left: -145px;
        //html[data-locale="KR"] & {
        //  top: 190px;
        //  .slick-dots {
        //    bottom: 0;
        //  }
        //}
        .slick-list {
          overflow: visible;
        }
        .slick-dots {
          position: relative !important;
          bottom: 0;
          right: -10px;
          .slick-active button {
            background-position-y: -22px;
          }
          & button {
            width: 22px;
            height: 22px;
            background-size: 100% auto;
          }
        }
      }
      &-img {
        width: 270px !important;
        height: 280px;
        margin-left: 10px;
        &:after {
          top: -28px;
          left: 0;
          width: 270px;
          height: 330px;
        }
        &.drag-img-1 {
          &:after {
            .ko & {
              @include bg(
                $bg: "../assets/img/ko/purple_drag_bg_1_m.png",
                $cover: cover
              );
            }
            .en & {
              @include bg(
                $bg: "../assets/img/en/purple_drag_bg_1_en_m.png",
                $cover: cover
              );
            }
            .zh & {
              @include bg(
                $bg: "../assets/img/zh/purple_drag_bg_1_zh_m.png",
                $cover: cover
              );
            }
            .ja & {
              @include bg(
                $bg: "../assets/img/ja/purple_drag_bg_1_ja_m.png",
                $cover: cover
              );
            }
          }
        }
        &.drag-img-2 {
          &:before {
            @include position(
              $position: absolute,
              $width: 115px,
              $height: 139px,
              $top: 84px,
              $left: -43px
            );
            @include bg(
              $bg: "../assets/img/purple_line_bg_m.png",
              $cover: cover
            );
          }
          &:after {
            .ko & {
              @include bg(
                $bg: "../assets/img/ko/purple_drag_bg_2_m.png",
                $cover: cover
              );
            }
            .en & {
              @include bg(
                $bg: "../assets/img/en/purple_drag_bg_2_en_m.png",
                $cover: cover
              );
            }
            .zh & {
              @include bg(
                $bg: "../assets/img/zh/purple_drag_bg_2_zh_m.png",
                $cover: cover
              );
            }
            .ja & {
              @include bg(
                $bg: "../assets/img/ja/purple_drag_bg_2_ja_m.png",
                $cover: cover
              );
            }
          }
        }
        &.drag-img-3 {
          &:after {
            .ko & {
              @include bg(
                $bg: "../assets/img/ko/purple_drag_bg_3_m.png",
                $cover: cover
              );
            }
            .en & {
              @include bg(
                $bg: "../assets/img/en/purple_drag_bg_3_en_m.png",
                $cover: cover
              );
            }
            .zh & {
              @include bg(
                $bg: "../assets/img/zh/purple_drag_bg_3_zh_m.png",
                $cover: cover
              );
            }
            .ja & {
              @include bg(
                $bg: "../assets/img/ja/purple_drag_bg_3_ja_m.png",
                $cover: cover
              );
            }
          }
        }
      }
    }

    &__btn {
      &-wrap-top {
        display: none;
      }
      &-wrap-bottom {
        display: block;
        @include position($position: absolute, $top: 526px);
        left: 50%;
        font-size: 0;
      }
      .ko & {
        width: 168px;
        height: 41px;
        &:after {
          @include bg($bg: "../assets/img/ko/purple_btn_m.png", $cover: cover);
          top: -38px;
          left: -15px;
          width: 198px;
          height: 113px;
        }
        &-wrap-bottom {
          margin-left: -84px;
        }
      }
      .zh & {
        width: 168px;
        height: 41px;
        &:after {
          @include bg(
            $bg: "../assets/img/zh/purple_btn_zh_m.png",
            $cover: cover
          );
          top: -36px;
          left: -13px;
          width: 193px;
          height: 113px;
        }
        &-wrap-bottom {
          margin-left: -84px;
        }
      }
      .en & {
        width: 208px;
        height: 41px;
        &:after {
          @include bg(
            $bg: "../assets/img/en/purple_btn_en_m.png",
            $cover: cover
          );
          top: -36px;
          left: -12px;
          width: 232px;
          height: 113px;
        }
        &-wrap-bottom {
          margin-left: -104px;
        }
      }
      .ja & {
        width: 208px;
        height: 41px;
        &:after {
          @include bg(
            $bg: "../assets/img/ja/purple_btn_ja_m.png",
            $cover: cover
          );
          top: -36px;
          left: -12px;
          width: 232px;
          height: 113px;
        }
        &-wrap-bottom {
          margin-left: -104px;
        }
      }
      &:after {
        pointer-events: none;
      }
    }
    &__info-txt{
      display: none;
    }
  }
}
</style>
